var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"pb-lg-5 pt-lg-5"},[_c('b-jumbotron',{attrs:{"bg-variant":"white"},scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._v("Page not found")]},proxy:true}])},[_vm._v(" "),_c('h4',[_c('router-link',{attrs:{"to":{name: 'home'}}},[_vm._v("Home page")])],1)])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-076b38b6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/PageNotFound.vue
// module id = null
// module chunks = 